import script from "./EventModalObserved.vue?vue&type=script&setup=true&lang=js"
export * from "./EventModalObserved.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__